import React, { useContext, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { useWizard } from '../hooks/WizardHooks';
import { AppContext } from '../state/AppContextProvider';
import { ActionType } from '../state/GlobalState';

export const PrivateRoute = ({ component, ...rest }: any) => {
  const { state, dispatch } = useContext(AppContext);

  const { showWizard, wizardSteps } = useWizard();

  const location = useLocation();

  function renderFn(props: any) {
    if (state.isAuthLoaded) {
      if (state.isConnected) {
        if (
          showWizard() &&
          !rest.path[0].startsWith('/wizard') &&
          rest.path !== '/debug' &&
          wizardSteps[0] !== 'done'
        ) {
          return <Redirect to={'/wizard/' + wizardSteps[0]} />;
        } else if (rest.path[0].startsWith('/wizard') && !showWizard()) {
          return <Redirect to="/news" />;
        } else {
          return React.createElement(component, props);
        }
      } else {
        return <Redirect to="/" />;
      }
    }
    return <p>Loading...</p>;
  }

  useEffect(() => {
    if( state.isAuthLoaded && !state.isConnected ) {
      // Store requested path into global state and redirect to the landing page
      dispatch({
        type: ActionType.SetRequestedPath,
        payload: location.pathname,
      });
    }
  }, [dispatch, state.isAuthLoaded, state.isConnected, location]);

  return <Route {...rest} render={renderFn} />;
};
